import { API_AUTH } from "./common";

const THONGKETHUApi = {
  list: ({
    tenKH,
    loaiKH,
    tinhtrangKH,
    trangthaiKH,
    nguonKH,
    pageIndex,
    pageSize,
  }) =>
    API_AUTH.get(
      `thongke/thu?tenKH=${tenKH}&loaiKH=${loaiKH}&tinhtrangKH=${tinhtrangKH}&trangthaiKH=${trangthaiKH}&nguonKH=${nguonKH}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
      {}
    ),
};

export default THONGKETHUApi;
